import FBtn from './FBtn.vue'

export default FBtn
